// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2ZubQ","header":"ReportDetails_header__13KZA","title":"ReportDetails_title__M3DAU","left":"ReportDetails_left__3TB58"};